export default "__VITE_ASSET__CQGo77FK__"